/**
 * Thin wrapper around the create-alacarte-checkout edge function for
 * surfaces that need to invoke à la carte checkout with feature keys
 * outside of the legacy ALACARTE_ITEMS catalog (e.g. v3.1 community
 * add-ons: community_addon_single, community_addon_bundle).
 *
 * The SKU → Stripe price ID mapping is resolved server-side via the
 * `alacarte_prices` table. Never hardcode price IDs in the frontend.
 *
 * For the legacy 14-item catalog use `startAlacarteCheckout` from
 * `@/lib/billing/alacarte` which carries the typed feature-key union.
 */
import { supabase } from "@/integrations/supabase/client";

export type StartAlacarteCheckoutArgs = {
  feature_key: string;
  purchase_type: "monthly" | "one_time";
  success_url: string;
  cancel_url: string;
  event_id?: string;
  app?: "fryqnc" | "pulsynq" | "mindlynq";
};

export async function startAlacarteCheckout(
  args: StartAlacarteCheckoutArgs,
): Promise<string | null> {
  const { data, error } = await supabase.functions.invoke<{
    url?: string;
    error?: string;
  }>("create-alacarte-checkout", { body: args });

  if (error) throw new Error(error.message);
  if (data && "error" in data && data.error) throw new Error(String(data.error));
  if (!data?.url) throw new Error("No checkout URL returned");
  return data.url;
}
